import { Person } from '@fs/zion-person'
import { type BasePerson } from '@fs/zion-tree-types'
import React, { type ComponentProps } from 'react'
import PersonCreatedDate from './PersonCreatedDate'
import PersonTextAlignmentDecorator from '../common/PersonTextAlignmentDecorator'
import { type AnalysisFullPerson } from '../analysis/types'

type Props = Omit<ComponentProps<typeof Person>, 'personObj'> & {
  /** The width the Person avatar renders at, which the Added date aligns its text to */
  avatarWidth: ComponentProps<typeof PersonTextAlignmentDecorator>['avatarSize']
  personObj: Partial<BasePerson> | Partial<AnalysisFullPerson> | undefined
}

export default function PersonAndDateAdded({ avatarWidth, personObj, ...props }: Props): JSX.Element {
  let creationDateMs: number | undefined
  if (personObj && 'creationDateMs' in personObj && typeof personObj.creationDateMs === 'number') {
    creationDateMs = personObj.creationDateMs
  } else if (personObj && 'initialCreationDateMs' in personObj && typeof personObj.initialCreationDateMs === 'number') {
    creationDateMs = personObj.initialCreationDateMs
  }

  return (
    <div>
      <Person personObj={personObj} {...props} />
      {creationDateMs && (
        <PersonTextAlignmentDecorator avatarSize={avatarWidth}>
          <PersonCreatedDate size="xs" secondary creationDateMs={creationDateMs} />
        </PersonTextAlignmentDecorator>
      )}
    </div>
  )
}
